export const formatPhoneNumber = (number: string) => `+${number}`;
